var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header none"},[(_vm.$route.path != '/')?_c('div',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("HOME")]),_vm._v(" > "),_vm._t("default")],2):_c('div',[_vm._v(" HOME ")])])}
var staticRenderFns = []

export { render, staticRenderFns }